<template>
  <table v-if="data.courseActivations.length > 0" class="ca-table">
    <colgroup>
      <col v-for="caIndex in data.courseActivations.length" :key="caIndex" :width="colWidth" />
    </colgroup>
    <tr>
      <th v-for="caIndex in data.courseActivations.length" :key="caIndex" class="cs-signInQuery-weekCell">
        <span v-if="!!getCourseActivation(caIndex)">{{`课节${getCANameSuffix(caIndex)}：${getCAField(caIndex, "ActiveTimeText")}`}}</span>
        <span v-else>&nbsp;</span>
      </th>
    </tr>
    <tr>
      <td v-for="caIndex in data.courseActivations.length" :key="caIndex">
        <courseActivationCell :data="getCourseActivation(caIndex)" />
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "weekCell",
  components: {
    courseActivationCell: () => import("./courseActivationCell.vue"),
  },
  props: {
    colWidth: {
      type: Number,
      default: 140,
    },
    data: {
      type: Object,
      default: () => ({
        courseActivations: [],
      }),
    },
  },
  methods: {
    getCourseActivation(caIndex) {
      let caList = this.data.courseActivations;
      return caList.length >= caIndex ? caList[caIndex - 1] : null;
    },
    getCAField(caIndex, fieldName) {
      let caEntity = this.getCourseActivation(caIndex);
      if (!!caEntity && Object.keys(caEntity).contains(fieldName))
        return caEntity[fieldName];

      return null;
    },
    getCANameSuffix(caIndex) {
      let caEntity = this.getCourseActivation(caIndex);

      if (!!caEntity) {
        if (
          caEntity.CourseActivationType ===
          this.GLOBAL.enumCourseActivationType.EmailVideo
        )
          return "(Email)";

        if (!caEntity.HasSignIn) return "(免计签到)";
      }

      return String.empty;
    },
  },
};
</script>

<style lang="scss" scoped>
.ca-table {
  width: 100%;

  tr {
    background-color: transparent;

    th,
    td {
      background-color: transparent;
      padding: 0;
      text-align: center;
    }

    td {
      border-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList4/weekCell.vue